import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const ReactionVoteYesIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <circle cx="8" cy="8" fill="#33AB6F" r="8" />
    <path
      d="M10.2962 5.01429C10.7163 4.55655 11.4279 4.52605 11.8857 4.94617C12.3434 5.3663 12.3739 6.07793 11.9538 6.53568L7.41073 11.4857C7.19771 11.7178 6.89694 11.8499 6.58192 11.85C6.26686 11.85 5.96617 11.7178 5.75311 11.4857L3.54618 9.08143L3.47279 8.99266C3.13164 8.53577 3.18517 7.8858 3.61429 7.49193C4.0434 7.09807 4.69558 7.10026 5.12162 7.47918L5.20379 7.56004L6.58148 9.06121L10.2962 5.01429Z"
      fill="white"
    />
  </svg>
);
